import React from "react";
import { CheckCircleIcon, ExclamationCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import { AudiitItemLevel, generateAuditItems } from "./TrueScanAuditResultsGenerator";
import { CMPAuditDto } from "../../../../common/service/server/dto/TrueScanResultsDto";

type TrueScanAuditResultsProps = {
  cmpAudit?: CMPAuditDto;
};

export const TrueScanAuditResults = ({ cmpAudit }: TrueScanAuditResultsProps) => {
  const sortedAuditItems = generateAuditItems(cmpAudit);

  return (
    <div className="tw-boundary">
      <h2 className="text-lg font-bold mb-4">Website Check</h2>

      <ul className="space-y-3">
        {sortedAuditItems.map((item) => (
          <li
            key={item.name}
            className={`flex flex-col p-3 rounded ${
              item.level === AudiitItemLevel.PASSED
                ? "bg-green-50"
                : item.level === AudiitItemLevel.WARNING
                ? "bg-amber-100"
                : "bg-red-50"
            }`}
          >
            <div className="flex items-center mb-1">
              <div
                className={`p-1 rounded-full mr-3 ${
                  item.level === AudiitItemLevel.PASSED
                    ? "bg-green-100 text-green-600"
                    : item.level === AudiitItemLevel.WARNING
                    ? "bg-amber-100 text-amber-700"
                    : "bg-red-100 text-red-600"
                }`}
              >
                {item.level === AudiitItemLevel.PASSED ? (
                  <CheckCircleIcon className="w-[20px] h-[20px] text-green-600" />
                ) : item.level === AudiitItemLevel.WARNING ? (
                  <ExclamationCircleIcon className="w-[20px] h-[20px] text-amber-700" />
                ) : (
                  <XCircleIcon className="w-[20px] h-[20px] text-red-500" />
                )}
              </div>
              <div>
                <span className="flex-1">{item.name}</span>
                {item.helpText && <p className="text-sm text-gray-500">{item.helpText}</p>}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
